export class Subscriber {
    constructor(initialItem) {
        this._callbacks = [];
        this._allScheduled = false;
        this._currentItem = initialItem;
    }
    _scheduleUpdate() {
        if (this._timerId) {
            return;
        }
        // FIXME: node typings leakage
        // @ts-ignore
        this._timerId = setTimeout(() => this._notify(), 0);
    }
    _notify() {
        var _a;
        const current = (_a = this._nextItem) !== null && _a !== void 0 ? _a : this._currentItem;
        const scheduled = this._scheduledItems;
        this._currentItem = current;
        this._nextItem = undefined;
        this._scheduledItems = undefined;
        this._timerId = undefined;
        if (this._allScheduled) {
            this._allScheduled = false;
            for (const cb of this._callbacks) {
                if (this._callbacks.includes(cb)) {
                    cb(current);
                }
            }
        }
        else if (scheduled) {
            for (const cb of scheduled) {
                cb(current);
            }
        }
    }
    subscribe(cb) {
        var _a;
        if (this._callbacks.indexOf(cb) === -1) {
            this._callbacks.push(cb);
        }
        if (!this._allScheduled && !((_a = this._scheduledItems) === null || _a === void 0 ? void 0 : _a.includes(cb))) {
            this._scheduledItems = [...(this._scheduledItems || []), cb];
            this._scheduleUpdate();
        }
        return () => {
            this.unsubscribe(cb);
        };
    }
    unsubscribe(cb) {
        this._callbacks = this._callbacks.filter((item) => item !== cb);
    }
    get currentItem() {
        return this._currentItem;
    }
    next(item) {
        this._allScheduled = true;
        this._nextItem = item;
        this._scheduleUpdate();
    }
}
//# sourceMappingURL=Subscriber.js.map